// extracted by mini-css-extract-plugin
export var footer = "_ly-0";
export var inherit = "_ly-1";
export var input = "_ly-2";
export var modalContent = "_ly-3";
export var quillEditor = "_ly-4";
export var subtitle = "_ly-5";